// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShowReel_wrapper__F95JD","showreel":"ShowReel_showreel__6ZNfo","image":"ShowReel_image__d2Bj8"};